<template>
	<el-dialog :title="title" center :visible.sync="dialogVisible" :close-on-click-modal="false" :close-on-press-escape="false" width="400px">
		<el-form ref="form" :model="form" :rules="rules" label-width="100px" size="small">
			<el-form-item label="名称" prop="levelName">
				<el-input v-model="form.levelName" placeholder="请输入名称"></el-input>
			</el-form-item>
			<el-form-item label="编码" prop="levelCode">
				<el-input v-model="form.levelCode" placeholder="请输入编码"></el-input>
			</el-form-item>
			<el-form-item label="显示名称" prop="showId">
				<el-select v-model="form.showId" placeholder="请选择显示名称">
					<el-option v-for="item in showNameList" :key="item.id" :label="item.showName" :value="item.id"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="等级" prop="level">
				<el-select v-model="form.level" placeholder="请选择等级">
					<el-option v-for="item in 15" :key="item" :label="item == 1 ? `${item} 最低` : item" :value="item"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="前置等级" prop="preId">
				<el-select v-model="form.preId" placeholder="请选择前置等级">
					<el-option label="无" value=""></el-option>
					<el-option v-for="item in preLevelList" :key="item.id" :label="item.levelName" :value="item.id" :disabled="form.id === item.id"></el-option>
				</el-select>
			</el-form-item>
		</el-form>
		<span slot="footer" class="dialog-footer">
			<el-button @click="handleClose">取 消</el-button>
			<el-button type="primary" :loading="submitLoading" @click="handleSubmit">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
import { debounce } from "@/utils/debounce";
import { courseSkillLevelList, courseSkillLevelAdd, courseSkillLevelUpdate, courseSkillShowList } from "@/api/skill";
export default {
	data() {
		return {
			dialogVisible: false,
			submitLoading: false,
			preLevelList: [],
			showNameList: [],
			title: "新增评价逻辑",
			form: {
				skillId: "",
				levelName: "",
				levelCode: "",
				showId: "",
				level: "",
				preId: "",
			},
			rules: {
				levelName: [{ required: true, message: "请输入名称", trigger: "blur" }],
				levelCode: [{ required: true, message: "请输入编码", trigger: "blur" }],
				showId: [{ required: true, message: "请选择显示名称", trigger: "change" }],
				level: [{ required: true, message: "请选择等级", trigger: "change" }],
			},
		};
	},
	methods: {
		// 初始化弹窗
		init(skillId, dt) {
			this.dialogVisible = true;
			this.submitLoading = false;
			this.$nextTick(() => {
				this.$refs.form.resetFields();
				this.form.skillId = skillId;
				this.form.level = 1;
				if (dt) {
					this.title = "编辑评价逻辑";
					this.form.id = dt.id;
					this.form.levelName = dt.levelName;
					this.form.levelCode = dt.levelCode;
					this.form.showId = dt.showId;
					this.form.level = dt.level;
					this.form.preId = dt.preId || "";
				} else {
					this.title = "新增评价逻辑";
					delete this.form.id;
				}
				// 获取前置等级列表
				this.getPreLevelList(skillId);
				this.getShowNameList();
			});
		},
		// 关闭弹窗
		handleClose() {
			this.dialogVisible = false;
			this.submitLoading = true;
		},
		// 获取列表
		getShowNameList() {
			courseSkillShowList({ skillId: this.form.skillId }, true).then((res) => {
				if (res.code != "0") return this.$message.error(res.msg);
				this.showNameList = res.data;
			});
		},
		// 获取前置等级列表
		getPreLevelList(skillId) {
			courseSkillLevelList({ skillId }).then((res) => {
				this.preLevelList = res.data || [];
			});
		},
		// 提交表单
		handleSubmit: debounce(function () {
			if (this.submitLoading) return;
			this.$refs.form.validate((valid) => {
				if (!valid) return;
				const api = this.form.id ? courseSkillLevelUpdate : courseSkillLevelAdd;
				const msg = this.form.id ? "编辑成功" : "新增成功";
				api(this.form, true).then((res) => {
					this.submitLoading = false;
					if (res.code != "0") return this.$message.error(res.msg);
					this.$message.success(msg);
					this.handleClose();
					this.$emit("refresh", this.form.skillId);
				});
			});
		}, 300),
	},
};
</script>

<style scoped></style>
